module.exports = __webpack_public_path__ + "static/media/asguest.a289bdf4.jpg";